import moment from "moment";

function getPercentCompleteTestPlans(pack) {
  const {
    completion: { complete, total },
  } = pack;

  if (total < 1) {
    return 0;
  }

  return Math.floor((complete / total) * 100);
}

function getPercentCompleteTime(pack) {
  const today = Date.now();

  const uatEnd = moment.utc(pack.uatEnd).format("x");
  const uatStart = moment.utc(pack.uatStart).format("x");

  if (today < uatStart) {
    return 0;
  }

  const totalTime = uatEnd - uatStart;
  const elapsedTime = today - uatStart;

  const percentCompleteTime = Math.floor((elapsedTime / totalTime) * 100);

  if (percentCompleteTime > 100) {
    return 100;
  }

  return percentCompleteTime;
}

function getStatus(pack) {
  const percentCompleteTime = getPercentCompleteTime(pack);
  const percentCompleteWork = getPercentCompleteTestPlans(pack);

  const percentBehind = percentCompleteTime - percentCompleteWork;

  if (percentBehind <= 10) {
    return 1;
  }

  if (percentBehind <= 15) {
    return 2;
  }

  if (percentBehind <= 20) {
    return 3;
  }

  return 4;
}

const labelMap = {
  1: "On Track",
  2: "Watch",
  3: "Behind",
  4: "Critical",
};

function getStatusLabel(pack) {
  const status = getStatus(pack);
  const label = labelMap[status];

  // IF there are ONLY non-qualify Progression Bar calculation release notes in a pack then the Progression Status remains at "On Track".
  if (pack.releaseNoteTotalNonQualifying && pack.releaseNoteTotalNonQualifying === pack.releaseNoteTotalPublished) {
    return "On Track";
  }

  if (!label) {
    return "--";
  }

  return label;
}

export default {
  getPercentCompleteTestPlans,
  getPercentCompleteTime,
  getStatus,
  getStatusLabel,
};
